
<template>
    <v-container fluid grid-list-xl class="login-container" style="overflow: hidden !important;">
        <v-layout  row wrap>

            <v-flex lg8 xs12 class="user-registration-section" >
                <div class="logo-language-selection registration">
                    <img v-if="logo" v-bind:src="logo" alt="smass logo"  class="logo">
                </div>

                <div class="scrolling-content-registration">

                    <div class="user-registration-form">
                        <v-toolbar flat dense >
                            <v-toolbar-title class="font-size-big no-margin-left color-headings-text font-weight-bold">{{text("db.global.TYPE_GTS_REGISTRATION_TITLE_B")}}</v-toolbar-title>
                        </v-toolbar>

                        <div class=" pb-2">
                            <v-form ref="userRegistrationForm" v-model="valid" class="margin-bottom-xl">

                                <v-layout row wrap>
                                    <v-flex xs12 sm3>
                                        <div class="salutation">

                                            <div v-if="salutationList">
                                                <v-radio-group
                                                    v-model="salutation"
                                                    v-validate="validationRules.salutation"
                                                    data-vv-name="salutation"
                                                    :error-messages="getValidationErrorMsg('salutation')"
                                                    row
                                                    class="radio-group--required">

                                                    <v-radio v-for="salutation in salutationList"
                                                             :key="'salutation-'+ salutation.key"
                                                             :label="salutation.name"
                                                             :value="salutation.key"
                                                             color="primary"
                                                             class="salutation-change"
                                                             @change="onChange"
                                                    ></v-radio>

                                                </v-radio-group>
                                            </div>

                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm9></v-flex>
                                </v-layout>


                                <v-layout row wrap>
                                    <v-flex xs12 sm4>
                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="firstName"
                                                :placeholder="text('api.registration.firstname')"
                                                v-model="firstName"
                                                v-validate="validationRules.firstName"
                                                data-vv-name="firstName"
                                                :error-messages="getValidationErrorMsg('firstName')"
                                                tabindex="3"
                                                class="input-group--required"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="institution"
                                                :placeholder="text('api.registration.institution')"
                                                v-model="institution"
                                                v-validate="validationRules.institution"
                                                data-vv-name="institution"
                                                :error-messages="getValidationErrorMsg('institution')"
                                                tabindex="8"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <div class="user-registration-input-field padding-right-l">
                                            <v-text-field
                                                type="text"
                                                name="email"
                                                :placeholder="text('api.registration.email')"
                                                v-model="email"
                                                v-validate="validationRules.email"
                                                data-vv-name="email"
                                                :error-messages="getValidationErrorMsg('email')"
                                                tabindex="13"
                                                class="input-group--required"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>

                                    <v-flex xs12 sm4>
                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="name"
                                                :placeholder="text('api.registration.lastname')"
                                                v-model="name"
                                                v-validate="validationRules.name"
                                                data-vv-name="name"
                                                :error-messages="getValidationErrorMsg('name')"
                                                tabindex="4"
                                                class="input-group--required"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="street"
                                                :placeholder="text('api.registration.street')"
                                                v-model="street"
                                                v-validate="validationRules.street"
                                                data-vv-name="street"
                                                :error-messages="getValidationErrorMsg('street')"
                                                tabindex="9"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <div class="user-registration-input-field padding-right-l">
                                            <v-text-field
                                                type="text"
                                                name="emailConfirmation"
                                                :placeholder="text('api.registration.email.confirm')"
                                                v-model="emailConfirmation"
                                                v-validate="validationRules.emailConfirmation"
                                                data-vv-name="emailConfirmation"
                                                :error-messages="getValidationErrorMsg('emailConfirmation')"
                                                tabindex="14"
                                                class="input-group--required"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>

                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm4>
                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="title"
                                                :placeholder="text('api.registration.usertitle')"
                                                v-model="title"
                                                v-validate="validationRules.title"
                                                data-vv-name="title"
                                                :error-messages="getValidationErrorMsg('title')"
                                                tabindex="5"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="postCode"
                                                :placeholder="text('api.registration.areacode')"
                                                v-model="postCode"
                                                v-validate="validationRules.postCode"
                                                data-vv-name="postCode"
                                                :error-messages="getValidationErrorMsg('postCode')"
                                                tabindex="10"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <div class="user-registration-input-field padding-right-l">
                                            <v-text-field
                                                type="text"
                                                name="username"
                                                :placeholder="text('api.registration.username')"
                                                v-model="username"
                                                v-validate="validationRules.username"
                                                data-vv-name="username"
                                                :error-messages="getValidationErrorMsg('username')"
                                                tabindex="15"
                                                class="input-group--required"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex xs12 sm4>
                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="phone"
                                                :placeholder="text('api.registration.phone')"
                                                v-model="phone"
                                                v-validate="validationRules.phone"
                                                data-vv-name="phone"
                                                :error-messages="getValidationErrorMsg('phone')"
                                                tabindex="6"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="city"
                                                :placeholder="text('api.registration.city')"
                                                v-model="city"
                                                v-validate="validationRules.city"
                                                data-vv-name="city"
                                                :error-messages="getValidationErrorMsg('city')"
                                                tabindex="11"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <div class="user-registration-input-field padding-right-l">
                                            <v-text-field
                                                :append-icon="isPasswordVisible ? 'visibility_off' : 'visibility'"
                                                :type="isPasswordVisible ? 'text' : 'password'"
                                                name="password"
                                                :placeholder="text('api.registration.password')"
                                                v-model="password"
                                                v-validate="validationRules.password"
                                                data-vv-name="password"
                                                :error-messages="getValidationErrorMsg('password')"
                                                :append-icon-cb="togglePasswordValueVisibility"
                                                tabindex="16"
                                                class="input-group--required password-input"
                                                :class="{'password-visibility': isPasswordVisible}"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex xs12 sm4>
                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="mobile"
                                                :placeholder="text('api.registration.mobile')"
                                                v-model="mobile"
                                                v-validate="validationRules.mobile"
                                                data-vv-name="mobile"
                                                :error-messages="getValidationErrorMsg('mobile')"
                                                tabindex="7"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <div class="user-registration-input-field select-option padding-right-xxl">
                                            <v-select
                                                :label="text('api.registration.country')"
                                                :items="getCountryList"
                                                name="country"
                                                item-text="name"
                                                item-value="id"
                                                v-model="country"
                                                v-validate="validationRules.country"
                                                data-vv-name="country"
                                                :error-messages="getValidationErrorMsg('country')"
                                                append-icon="keyboard_arrow_down"
                                                tabindex="12"
                                            ></v-select>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <div class="user-registration-input-field padding-right-l">
                                            <v-text-field
                                                :append-icon="isPasswordConfirmationVisible ? 'visibility_off' : 'visibility'"
                                                :type="isPasswordConfirmationVisible ? 'text' : 'password'"
                                                name="passwordConfirmation"
                                                :placeholder="text('api.registration.password.again')"
                                                v-model="passwordConfirmation"
                                                v-validate="validationRules.passwordConfirmation"
                                                data-vv-name="passwordConfirmation"
                                                :error-messages="getValidationErrorMsg('passwordConfirmation')"
                                                :append-icon-cb="togglePasswordConfirmationValueVisibility"
                                                tabindex="17"
                                                class="input-group--required password-input"
                                                :class="{'password-visibility': isPasswordConfirmationVisible}"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex xs12 sm12>
                                        <div class="padding-right-xxl checks">
                                            <v-checkbox
                                                :label="text('api.registration.newsletter')"
                                                v-model="hasNewsletter"
                                                color="primary"
                                                tabindex="19"
                                                class="newsLetter"
                                            ></v-checkbox>
                                        </div>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm12>
                                        <div class="padding-right-xxl checks">
                                            <v-checkbox
                                                v-model="legalTerms"
                                                v-validate="validationRules.legalTerms"
                                                data-vv-name="legalTerms"
                                                :error-messages="getValidationErrorMsg('legalTerms')"
                                                color="primary"
                                                tabindex="18"
                                                class="legalTerms"
                                            ></v-checkbox>
                                            <span class="go-to-terms">
                                                {{text('api.registration.terms.prefix') }}
                                                <span
                                                    v-if="hasDocAddressValue"
                                                    @click="openDocPopup(4)"
                                                    class="terms-link color-primary"
                                                >{{ text('api.registration.terms.link') }}</span>
                                                <span v-else>{{ text('api.registration.terms.link') }}</span>
                                            </span>
                                        </div>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex xs12 sm4>
                                        <div class="padding-right-l">
                                            <v-btn block @click="submitUserRegistrationForm" :disabled="hasEmptyRequiredFields || hasErrorMessagesFromApi || errors.any()" color="primary" class="registration-btn" tabindex="20">{{text('api.button.send')}}</v-btn>
                                        </div>
                                    </v-flex>
                                </v-layout>

                            </v-form>
                            <div class="color-body">
                                <span class="float-left">{{text('api.pro.userRegistration.alreadyRegistered')}}</span>&nbsp;
                                <router-link :to="'/'" class="color-primary underline-none">{{text('api.login.button')}}</router-link>
                            </div>
                        </div>
                    </div>


                    <div class="powered-by">
                        <span class="color-body font-weight-light">{{text('db.global.TYPE_GTS_COMMERCIAL_FIELD_TITLE')}} </span>
                        <in4-medicine-logo ></in4-medicine-logo>
                    </div>
                    <doc-popup
                    :content-class="'user-registration-doc-popup'"
                    :persistent="false"
                    :card-class="'no-padding'"
                    :max-width="800"
                    >

                    </doc-popup>
                </div>


            </v-flex>


            <v-flex lg4 hidden-xs-only hidden-sm-only hidden-md-only>

                <div class="container-img">
                    <img src="static/img/registration_bg.png" class="registartion-bg" alt="" />
                    <div class="centered-text">
                        <h4 v-html="text('db.global.TYPE_GTS_REGISTRATION_TITLE_A')"></h4>
                        <span v-html="text('db.global.TYPE_GTR_PAGE_REGISTRATION_TEXTFIELD_1')"></span>
                    </div>
                </div>

            </v-flex>
        </v-layout>
    </v-container>

</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import Vue from "vue";
import DocPopup from "../shared/DocPopup";
import In4MedicineLogo from "../svg/shared/in4MedicineLogo";

export default {
        name: 'ForgotPasswordPage',
    components: {In4MedicineLogo, DocPopup},
    data() {
            return {
                // error: null,
                valid: true,
                isPasswordVisible: false,
                isPasswordConfirmationVisible: false,

                salutation: null,
                firstName: '',
                name: '',
                title: '',
                phone: '',
                mobile: '',
                institution: '',
                street: '',
                postCode: '',
                city: '',
                country: '',
                email: '',
                emailConfirmation: '',
                username: '',
                password: '',
                passwordConfirmation: '',
                hasNewsletter: false,
                legalTerms: false,

                // Used for serverside validation.
                errorMessagesFromApi: {
                    email: ""
                },
                radioButtonPlugin: Vue.RadioButton.RadioButtonSvg,
                checkBoxPlugin: Vue.CheckBox.checkBoxSvg
            }
        },
        computed: {
            ...mapGetters({
                languageList: 'TranslationStore/getLanguageList',
                getCountryList: 'UserStore/getCountryList',
                getSalutationList: 'UserStore/getSalutationList',
                logo: 'TranslationStore/getLogo',
                getSelfRegistrationEnabled: 'TranslationStore/getSelfRegistrationEnabled',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getDocApplicationType: 'TranslationStore/getDocApplicationType'
            }),

            languageListForDropdown () {

                let langsForDropdown = [];
                this.languageList.forEach((langKey) => {
                    langsForDropdown.push({
                        key: langKey,
                        name: this.text("api.language.name."+langKey)
                    });
                });
                return langsForDropdown;
            },

            selectedLang: {
                get () {
                    return this.$store.state["TranslationStore"].selectedLanguage;
                },
                set (newVal) {
                    this.$store.commit('TranslationStore/setSelectedLanguage', newVal);
                }
            },

            countryList () {
                let countryList = Object.keys(this.getCountryList).map((crtCountryKey, crtIndex) => {
                    return { name: this.getCountryList[crtCountryKey], key: parseInt(crtCountryKey) };
                });
                return countryList;
            },
            salutationList () {
                let salutationList = Object.keys(this.getSalutationList).map((crtSalutationKey, crtIndex) => {
                    return { name: this.getSalutationList[crtSalutationKey], key: parseInt(crtSalutationKey) };
                });
                return salutationList;
            },

            /**
             * Validation rules for User Registration form. They are used by Vee-validate library.
             */
            validationRules () {
                return {
                    salutation: {
                        required: true
                    },
                    firstName: {
                        required: true,
                        max: 64
                    },
                    name: {
                        required: true,
                        max: 64
                    },
                    title: {
                        max: 64
                    },
                    institution: {
                        max: 128
                    },
                    street: {
                        max: 128
                    },
                    postCode: {
                        max: 32
                    },
                    city: {
                        max: 128
                    },
                    phone: {
                        max: 64
                    },
                    mobile: {
                        max: 64
                    },
                    username: {
                        required: true,
                        min: 6,
                        max: 128
                    },
                    email: {
                        required: true,
                        email: true,
                    },
                    emailConfirmation: {
                        is: this.email
                    },
                    password: {
                        required: true,
                        min: 6,
                        max: 72
                    },
                    passwordConfirmation: {
                        is: this.password
                    },
                    legalTerms: {
                        required: true
                    },
                }
            },

            /**
             * Check if there is one or more required field(s) that has not been completed. It helps us to disable/enable the Submit button.
             * @return {Boolean}
             */
            hasEmptyRequiredFields() {
                return (!this.salutation
                    || !this.firstName
                    || !this.name
                    || !this.username
                    || !this.email
                    || !this.emailConfirmation
                    || !this.password
                    || !this.passwordConfirmation
                    || (typeof this.legalTerms === "undefined" || this.legalTerms !== true)
                ) ? true : false;
            },

            /**
             * Checks if there is any error message caused by server-side validation. For example, when entered
             *      email address has already been used by another user. If there are error messages from API,
             *      they will have priority over any other active error messages that a field may have.
             * @return {Boolean}
             */
            hasErrorMessagesFromApi() {

                let errorsFromApi = Object.values(this.errorMessagesFromApi).filter((item) => {
                    return (item.length > 0) ? true : false;
                });

                return (errorsFromApi.length) ? true : false;
            },

            hasDocAddressValue() {
                const applicationType = this.getDocApplicationType();
                return (this.getAppPropertyValue("DOC_" + applicationType + "_ADDRESS_" + 4) !== null) ? true : false;
            },
        },

        watch: {
            email (newVal, oldVal) {
                // Reset error messages from API for email field when entered value is changed.
                this.errorMessagesFromApi.email = "";
            },
            hasNewsletter(newVal, oldVal) {
                if(newVal) {
                    let that = this;
                    setTimeout(function() {
                        let selectedCheck = document.getElementsByClassName('newsLetter')
                        let checkNewsletter = selectedCheck[0].getElementsByClassName('icon--checkbox');
                        checkNewsletter[0].innerHTML = that.checkBoxPlugin();
                    }, 100)
                }
            },
            legalTerms(newVal, oldVal) {
                if(newVal) {
                    let that = this;
                    setTimeout(function() {
                        let selectedCheck = document.getElementsByClassName('legalTerms')
                        let legalTerms = selectedCheck[0].getElementsByClassName('icon--checkbox');
                        legalTerms[0].innerHTML = that.checkBoxPlugin();
                    }, 100)
                }
            }
        },

        beforeCreate() {
            this.$store.dispatch("UserStore/loadAdditionalUserPageData");
        },

        beforeMount() {
            if (this.getSelfRegistrationEnabled) {
                this.$router.push('/user-registration');
            } else {
                this.$router.push('/');
            }
        },

        methods: {
            submitUserRegistrationForm () {

                this.$validator.validate().then((isValid) => {
                    if (isValid) {

                        let promiseUserReg = this.$store.dispatch("UserStore/submitUserRegistration", {
                            salutation: this.salutation,
                            username: this.username,
                            firstName: this.firstName,
                            name: this.name,
                            email: this.email,
                            password: this.password,
                            title: this.title,
                            institution: this.institution,
                            street: this.street,
                            postCode: this.postCode,
                            city: this.city,
                            country: this.country,
                            phone: this.phone,
                            mobile: this.mobilePhone,
                            hasNewsletter: this.hasNewsletter
                        });

                        promiseUserReg.then((response) => {

                            this.$router.push('/home');

                        });
                        promiseUserReg.catch((error) => {

                            if (typeof error === "string") {
                                alert(error);
                            }
                            else {
                                // Handle "duplicate email" error.
                                const RETURN_CODE_DUPLICATE_EMAIL = 104;

                                let responseReturnCode = (
                                    typeof error.serverResponse !== "undefined" &&
                                    typeof error.serverResponse.data !== "undefined" &&
                                    typeof error.serverResponse.data.returnCode !== "undefined"
                                ) ? error.serverResponse.data.returnCode : null;

                                if (responseReturnCode === RETURN_CODE_DUPLICATE_EMAIL) {
                                    this.errorMessagesFromApi.email = this.text("api.error.duplicate.email");
                                }
                            }
                        });
                    }
                });
            },


            /**
             * Returns an array containing validation rules for fields in User Registration form.
             * @param {String} field - Field identifier.
             * @return {Array} - Validation rules.
             */
            getValidationErrorMsg(field) {
                let errorMsg = [];

                let errorMsgList = {
                    salutation: {
                        required: this.text("api.error.field.required")
                    },
                    firstName: {
                        required: this.text("api.error.field.required"),
                        max: this.text("api.error.field.length.exceeded", [64])
                    },
                    name: {
                        required: this.text("api.error.field.required"),
                        max: this.text("api.error.field.length.exceeded", [64])
                    },
                    title: {
                        max: this.text("api.error.field.length.exceeded", [64])
                    },
                    institution: {
                        max: this.text("api.error.field.length.exceeded", [128])
                    },
                    street: {
                        max: this.text("api.error.field.length.exceeded", [128])
                    },
                    postCode: {
                        max: this.text("api.error.field.length.exceeded", [32])
                    },
                    city: {
                        max: this.text("api.error.field.length.exceeded", [128])
                    },
                    phone: {
                        max: this.text("api.error.field.length.exceeded", [64])
                    },
                    mobile: {
                        max: this.text("api.error.field.length.exceeded", [64])
                    },
                    username: {
                        required: this.text("api.error.field.required"),
                        min: this.text("api.error.username.too.short"),
                        max: this.text("api.error.field.length.exceeded", [128])
                    },
                    email: {
                        required: this.text("api.error.field.required"),
                        email: this.text("api.error.email.invalid")
                    },
                    emailConfirmation: {
                        is: this.text("api.error.email.match")
                    },
                    password: {
                        required: this.text("api.error.field.required"),
                        min: this.text("api.error.password.too.short"),
                        max: this.text("api.error.field.length.exceeded", [72])
                    },
                    passwordConfirmation: {
                        is: this.text("api.error.password.match")
                    },
                    legalTerms: {
                        required: this.text("api.error.agreement.accept")
                    }
                };

                // Check if there is any error message that doesn't come from form validator but must be displayed anyway.
                if (this.errorMessagesFromApi[field]) {
                    errorMsg.push(this.errorMessagesFromApi[field]);
                }
                // Look for errors from form validator.
                else {
                    let errorObj = this.errors.items.find((crtItem) => {
                        return !!(crtItem.field === field);
                    });

                    if (errorObj) {
                        if (errorMsgList[field][errorObj.rule]) {
                            errorMsg.push(errorMsgList[field][errorObj.rule]); // Use custom/translated error message.
                        }
                        else {
                            errorMsg.push(errorObj.msg); // No custom/translated error message found, so use the default message that comes from translation library (vee-validate lib).
                        }
                    }
                }

                return errorMsg;
            },


            togglePasswordValueVisibility() {
                this.isPasswordVisible = !this.isPasswordVisible;
            },
            togglePasswordConfirmationValueVisibility() {
                this.isPasswordConfirmationVisible = !this.isPasswordConfirmationVisible;
            },
            onChange($el) {
                let elem = $el;
                let clickedRadio = document.getElementsByClassName('salutation-change')[elem-1];
                let that = this;
                setTimeout(function() {
                    let radio = clickedRadio.getElementsByClassName('icon--radio');
                    radio[0].innerHTML = that.radioButtonPlugin()
                }, 100)

            },

            openDocPopup(code) {
                const applicationType = this.getDocApplicationType();

                const data = {
                    title : "api.doc." + applicationType.toLowerCase() + "." + code,
                    url : this.getAppPropertyValue("DOC_" + applicationType + "_ADDRESS_" + code),
                };

                this.$store.dispatch('DocStore/loadDocData', data);
            },

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
    .container.login-container {
        padding: 0;
        height: 100%;

        .layout {
            height: 100%;
            margin: 0;

            .flex.user-registration-section {
                padding: 40px 0;
                background-color: $color-background;
                position: relative;

                .logo-language-selection {
                    display: flex;

                    .logo {
                        height: 64px;
                        max-width: 195px;
                    }
                    .input-group--select {
                        padding-top: 0;
                        width: 20%;

                        .input-group__input .icon {
                            display: none;
                        }
                    }
                }

                .powered-by{
                    position: absolute;
                    margin-top: 65px;
                    width: 75%;

                    svg {
                        width: 146px;
                        position: relative;
                        top: 8px;
                        margin-left: 7px;
                    }
                }
                .user-registration-form {
                 //   position: absolute;
                    //  bottom: 20%;

                    form {
                        .user-registration-input-field {
                            position: relative;
                            display: flex;

                            img {
                                position: absolute;
                                top: 20px;
                                float: left;
                                width: 20px;
                            }
                            .input-group.input-group--text-field {
                                float: right;
                                width: 90%;
                            }
                        }
                        button {
                            height: 45px;
                            border-radius: 5px;

                            .btn__content {
                                font-size: $font-size-medium;
                                font-family: $font-weight-light;
                            }
                        }
                    }
                }
                .toolbar {
                    background-color: transparent;
                }
            }

            .flex {
                padding: 0;

                .carousel {
                    height: 100%;

                    .jumbotron__content{
                        h4 {
                            padding-bottom: 8px;
                            margin-bottom: 15px;

                            &:after {
                                content:"";
                                background: $color-brand-primary;
                                position: absolute;
                                top: 70px;
                                left: 37%;
                                height: 4px;
                                width: 25%;
                            }
                        }
                        span {
                            font-weight: $font-weight-light;
                        }
                    }
                }
            }
        }
    }


    @media only screen and (max-width: 600px) {
        .login-container {
            .layout .flex.user-registration-section .user-registration-form {
                width: 100%;
                padding-right: 40px;
            }
            .logo-language-selection img {
                margin-right: 50px;
            }
        }

        .logo-language-selection.registration {
            height: 80px;
        }

        .scrolling-content-registration {
            top: 110px;
            position: fixed;
            margin-left: auto;
            margin-right: auto;
            bottom: 0;
            margin-bottom: 20px;
            overflow: auto;
            padding-top: 0;
            width: 100%;
            overflow-x: hidden;
            background-color: $color-block-background;
        }



        .container.login-container {

            .layout {

                .flex.user-registration-section {
                    padding: 0;
                    padding-left: 34px;
                    padding-top: 40px;

                    .logo-language-selection {
                        padding-left: 0 !important;
                    }
                }
            }
        }


    }


    @media only screen and (min-width: 601px) and (max-width: 961px) {

        .login-container {
            .layout .flex.user-registration-section .user-registration-form {
                width: 100%;
              //  padding-right: 40px;
            }
            .logo-language-selection img {
                margin-right: 150px;
            }
        }
    }

    @media only screen and (min-width: 962px) and (max-width: 1200px) {
        .login-container {
            .layout .flex.user-registration-section .user-registration-form {
                width: 100%;
             //   padding-right: 40px;
            }
            .jumbotron__content {
                h4 {
                    font-size: 2rem ;
                    // SMASSDEV - 1119
                    // word-spacing: 0.16 * 2rem;
                    // line-height: 1.5 * 2rem;
                    // letter-spacing: 0.12 * 2rem;
                }
                span {
                    // SMASSDEV - 1119
                    font-size: $font-size-medium;
                    // word-spacing: $word-spacing-medium;
                    // line-height: $line-height-medium;
                    // letter-spacing: $letter-spacing-medium;
                }
            }
            .logo-language-selection img {
                margin-right: 30px;
            }
        }
    }

    @media only screen and (min-width: 1201px) and (max-width: 1699px) {
        .login-container {
            .layout .flex.user-registration-section .user-registration-form {
                width: 100%;
             //  padding-right: 40px;
            }
            .jumbotron__content {
                h4 {
                    font-size: 2.25rem ;
                    // SMASSDEV - 1119
                    // word-spacing: 0.16 * 2.25rem;
                    // line-height: 1.5 * 2.25rem;
                    // letter-spacing: 0.12 * 2.25rem;
                }
                span {
                    // SMASSDEV - 1119
                    font-size: $font-size-medium;
                    // word-spacing: $word-spacing-medium;
                    // line-height: $line-height-medium;
                    // letter-spacing: $letter-spacing-medium;
                }
            }
            .logo-language-selection img {
                margin-right: 50px;
            }
        }

        .salutation .input-group {
            padding-top: 0;
            width: 100% !important;
        }
    }

    @media only screen and (max-width: 1200px) {
        .salutation .input-group {
            padding-top: 0;
            width: 100% !important;
        }
    }

    @media only screen and (min-width: 1700px) {
        .login-container {
            .layout .flex.user-registration-section .user-registration-form {
                width: 100%;
             //   padding-right: 40px;
            }
            .jumbotron__content {
                h4 {
                    font-size: 2.625rem ;
                    // SMASSDEV - 1119
                    // word-spacing: 0.16 * 2.625rem;
                    // line-height: 1.5 * 2.625rem;
                    // letter-spacing: 0.12 * 2.625rem;
                }
                span {
                    // SMASSDEV - 1119
                    font-size: $font-size-big;
                    // word-spacing: $word-spacing-big;
                    // line-height: $line-height-big;
                    // letter-spacing: $letter-spacing-big;
                }
            }
            .logo-language-selection img {
                margin-right: 95px;
            }
        }
    }
    .fade-enter-active, .fade-leave-active, .fade-leave-to {
        position: absolute;
    }

    .user-registration-input-field .input-group {
     //   padding-top: 0;
    }

    .user-registration-input-field.select-option .input-group {
      //  padding-top: 18px;
    }

    /*img.registartion-bg {*/
        /*width: 100%;*/
        /*height: auto;*/
    /*}*/

    .logo-language-selection {
        padding-left: 34px;
    }

    @media only screen  and  (min-width: 601px) and (max-width: 1263px) {
        .scrolling-content-registration {
            position: fixed;
            overflow: auto;
            background-color: $color-block-background;
            top: 110px;
            bottom: 0;
            margin-bottom: 20px;
            width: 100%;
            padding: 0 34px;
        }
    }



    @media only screen  and  (min-width: 1264px) {
        .scrolling-content-registration {
            position: fixed;
            overflow: auto;
            top: 110px;
            background-color: $color-block-background;
            margin-bottom: 20px;
            bottom: 0;
            width:66%;
            padding: 0 34px;
            padding-left: 24px;
            margin-left: 10px;
        }

    }


    @media only screen and (min-height: 840px) {
        .container-img {
            position: relative;
            text-align: center;
            color: white;

            .centered-text {
                position: absolute;
                bottom: 20%;
                left: 30%;
                transform: translate(-20%, -20%);

                h4 {
                    font-size: 2.625rem ;
                    // SMASSDEV - 1119
                    // word-spacing: 0.16 * 2.625rem;
                    // line-height: 1.5 * 2.625rem;
                    // letter-spacing: 0.12 * 2.625rem;
                    margin-bottom: 30px;
                }
                &:after {
                    content: "";
                    background: $color-brand-primary;
                    position: absolute;
                    top: 70px;
                    left: 37%;
                    height: 4px;
                    width: 25%;
                }

            }
        }
    }


    @media only screen and (max-height: 839px) {

        .container-img {
            position: relative;
            text-align: center;
            color: white;

            .centered-text {
                position: absolute;
                bottom: 30%;
                left: 7%;
                right: 5%;
                transform: translate(0%, -20%);

                h4 {
                    font-size: 2.25rem ;
                    // SMASSDEV - 1119
                    // word-spacing: 0.16 * 2.25rem;
                    // line-height: 1.5 * 2.25rem;
                    // letter-spacing: 0.12 * 2.25rem;
                    margin-bottom: 30px;
                }
                &:after {
                    content: "";
                    background: $color-brand-primary;
                    position: absolute;
                    top: 70px;
                    left: 37%;
                    height: 4px;
                    width: 25%;
                }

            }
        }

    }

    .salutation .input-group {
        padding-top: 0;
        width: 60%;
    }

    @media only screen and (max-height: 912px) {
        .powered-by {
            margin-bottom: 23px;
        }
    }

    @media only screen and (max-height: 520px) {

        .user-registration-section .logo-language-selection img {
            display: block !important;
        }
    }

    .registration-btn {
        background-color: $color-brand-primary;
        color: $color-headings-text;
    }

    .go-to-terms {
        position: relative;
        top: -51px;
        left: 30px;
        color: $color-headings-text;
    }



</style>





// WEBPACK FOOTER //
// src/common/components/user-registration/UserRegistrationPage.vue